module.exports = __webpack_public_path__ + "static/media/powerline.0238b196.jpg";